import { RouteRecordRaw } from 'vue-router';

import BaseLayout from '@/layouts/base-layout.vue';
import { redirectLogged } from '@/router/middlewares/redirectLogged';
import { isProduction } from '@/utils/isProduction';

const SignIn = () => import('@/_redesign/modules/Entrance/pages/SignIn/SignIn.vue');
const IsBlockedOrBanned = () => import('@/_redesign/modules/Entrance/pages/SignIn/IsBlockedOrBanned.vue');

const RecoverPassword = () => import('@/_redesign/modules/Entrance/pages/Password/RecoverPassword.vue');
const ResetPassword = () => import('@/_redesign/modules/Entrance/pages/Password/ResetPassword.vue');

const getMeta = () => ({
  disableGuard: true,
  middleware: [redirectLogged],
  layout: {
    componentName: 'RedesignLayout',
    props: {
      isClosable: true,
      fetchProfile: false,
      onClose: () => {
        window.location.href = isProduction() ? 'https://amaiz.com' : '/';
      },
    },
  },
});

const ENTRANCE_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'sign-in',
    name: 'sign-in-manual',
    component: SignIn,
    meta: getMeta(),
  },
  {
    path: 'recover-password',
    name: 'recover-password',
    component: RecoverPassword,
    meta: getMeta(),
  },
  {
    path: 'reset-password',
    name: 'reset-password',
    component: ResetPassword,
    meta: getMeta(),
  },
  {
    path: 'banned',
    name: 'is-banned',
    component: IsBlockedOrBanned,
    meta: getMeta(),
  },
  {
    path: 'blocked',
    name: 'is-blocked',
    component: IsBlockedOrBanned,
    meta: getMeta(),
  },
];

export const ENTRANCE: RouteRecordRaw = {
  path: '/',
  name: 'entrance',
  component: BaseLayout,
  props: {
    fetchProfile: false,
  },
  redirect: ENTRANCE_CHILDREN[0],
  children: ENTRANCE_CHILDREN,
};
